import { Component } from '@angular/core';

@Component({
  selector: 'ultra-footer',
  styleUrls: ['./footer.component.scss'],
  template: `
    <span class="created-by">
      Desenvolvido por <b><a href="https://www.ultrasistemas.com.br/" target="_blank">Ultra Sistemas</a></b>
    </span>
    <!--div class="socials">
      <a href="#" target="_blank" class="ion ion-social-github"></a>
      <a href="#" target="_blank" class="ion ion-social-facebook"></a>
      <a href="#" target="_blank" class="ion ion-social-twitter"></a>
      <a href="#" target="_blank" class="ion ion-social-linkedin"></a>
    </div-->
  `,
})
export class FooterComponent {
}
